<template>
  <v-dialog :value="show" max-width="500" @input="(val) => outsideClick(val)">
    <v-card class="align-center d-flex flex-column">
      <CloseDialogButton :close="closeAuth" />
      <StorefrontImage class="display-none-height pt-10" size="large" />
      <EmailLogInContent
        :closeAuth="closeAuth"
        :email="email"
        :logInWithEmailAndPassword="logInWithEmailAndPassword"
        :password="password"
        :toAuthRoute="toAuthRoute"
        :toLogInRoute="toLogInRoute"
        :update="update"
      />
    </v-card>
  </v-dialog>
</template>

<script>
import CloseDialogButton from "@/components/UI/CloseDialogButton.vue";
import EmailLogInContent from "@/components/Auth/LogIn/Content/Email.vue";
import StorefrontImage from "@/components/UI/StorefrontImage.vue";

export default {
  name: "EmailLogInDialog",
  components: {
    CloseDialogButton,
    EmailLogInContent,
    StorefrontImage,
  },
  props: {
    closeAuth: Function,
    email: String,
    logInWithEmailAndPassword: Function,
    outsideClick: Function,
    password: String,
    show: Boolean,
    toAuthRoute: Function,
    toLogInRoute: Function,
    update: Function,
  },
};
</script>
<style scoped>
@media (max-height: 768px) {
  .display-none-height {
    display: none;
  }
}
</style>
